/**
 * Delikatesi GTM ecommerce events (Olitalia-tagged products only).
 * Events: select_item, view_item, add_to_cart → window.dataLayer
 */
class gtmEvents {
  constructor() {
    // Delegation so cart drawer / predictive search AJAX markup works without re-bind
    document.addEventListener("click", (e) => {
      const viewedEl = e.target.closest?.('[data-action="gtm-send-viewed"]');
      if (viewedEl) {
        this.selectItem(e, viewedEl);
        return;
      }
      const addedEl = e.target.closest?.('[data-action="gtm-send-added"]');
      if (addedEl) {
        this.addedToCart(e, addedEl);
      }
    });

    if (document.body?.dataset?.template === "product") {
      this.viewedItemPDP();
    }
  }

  /** @deprecated Prefer delegation; kept for callers that re-init after AJAX */
  initViewListeners(container = document) {
    container.querySelectorAll('[data-action="gtm-send-viewed"]').forEach((el) => {
      if (!el.hasAttribute("data-gtm-listener")) {
        el.setAttribute("data-gtm-listener", "true");
      }
    });
  }

  _parseSettings(productEl) {
    if (!productEl?.dataset?.settings) return null;
    try {
      return JSON.parse(productEl.dataset.settings);
    } catch (err) {
      console.warn("[GTM] invalid data-settings", err);
      return null;
    }
  }

  _resolveQuantity(productEl, triggerEl, settings) {
    const scope =
      triggerEl?.closest?.("form") ||
      productEl?.querySelector?.("form.product__form") ||
      productEl;
    const qtyInput = scope?.querySelector?.('[name="quantity"], [data-quantity-input]');
    if (qtyInput) {
      const n = Number(qtyInput.value);
      if (Number.isFinite(n) && n > 0) return n;
    }
    const fromSettings = Number(settings?.item_quantity);
    return Number.isFinite(fromSettings) && fromSettings > 0 ? fromSettings : 1;
  }

  _push(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (typeof console !== "undefined" && console.debug) {
      console.debug("[GTM]", payload.event, payload);
    }
  }

  selectItem(event, linkEl) {
    event.preventDefault();
    const productEl = linkEl.closest("[data-product]");
    if (!productEl) {
      console.warn("[GTM] missing [data-product] parent for select_item");
      const href = linkEl.href;
      if (href) window.location.href = href;
      return;
    }

    const settings = this._parseSettings(productEl);
    if (!settings) {
      const href = linkEl.href;
      if (href) window.location.href = href;
      return;
    }

    const productId = settings.item_id;
    const sku = settings.item_sku;
    const name = settings.item_name;
    const price = Number(settings.item_price) || 0;
    const quantity = Number(settings.item_quantity) || 1;
    const listName = settings.list_name;
    const tag = settings.item_tag || "";

    if (tag === "olitalia") {
      this._push({
        event: "select_item",
        ecommerce: {
          content_list_name: listName,
          content_type: "product",
          currency: "RSD",
          value: price * quantity,
          items: [
            {
              content_id: productId,
              content_sku: sku,
              contents: name,
              value: price,
              quantity: quantity,
              tag: tag,
            },
          ],
        },
      });
    }

    const href = linkEl.href;
    if (href) {
      setTimeout(() => {
        window.location.href = href;
      }, 200);
    }
  }

  viewedItemPDP() {
    const productEl = document.querySelector("[data-product-section][data-product], [data-product]");
    if (!productEl) return;

    const settings = this._parseSettings(productEl);
    if (!settings) return;

    const productId = settings.item_id;
    const sku = settings.item_sku;
    const name = settings.item_name;
    const price = Number(settings.item_price) || 0;
    const quantity = Number(settings.item_quantity) || 1;
    const tag = settings.item_tag || "";

    if (tag === "olitalia") {
      this._push({
        event: "view_item",
        ecommerce: {
          content_type: "product",
          currency: "RSD",
          value: price * quantity,
          items: [
            {
              content_id: productId,
              contents: name,
              content_sku: sku,
              price: price,
              quantity: quantity,
              tag: tag,
            },
          ],
        },
      });
    }
  }

  addedToCart(event, triggerEl) {
    const productEl = triggerEl.closest("[data-product]");
    if (!productEl) return;

    const settings = this._parseSettings(productEl);
    if (!settings) return;

    const productId = settings.item_id;
    const sku = settings.item_sku;
    const name = settings.item_name;
    const price = Number(settings.item_price) || 0;
    const quantity = this._resolveQuantity(productEl, triggerEl, settings);
    const tag = settings.item_tag || "";

    if (tag === "olitalia") {
      this._push({
        event: "add_to_cart",
        ecommerce: {
          content_type: "product",
          currency: "RSD",
          value: price * quantity,
          items: [
            {
              content_id: productId,
              content_sku: sku,
              contents: name,
              price: price,
              quantity: quantity,
              tag: tag,
            },
          ],
        },
      });
    }
  }
}

const gtmInstance = new gtmEvents();
window.gtmInstance = gtmInstance;
